import { Injectable } from "@angular/core";
import { DatePipe } from "@angular/common";
import { concat } from "rxjs";

@Injectable()
export class DateService {
  constructor(private datepipe: DatePipe) { }

  combineDateString(datePart: string, timePart: string): string {
    if (datePart == null || timePart == null ||
      datePart == '' || timePart == '') return null;

    let timePortions = timePart.split(' ');
    let timeTokens = timePortions[0].split(':');
    let hour = parseInt(timeTokens[0]);
    let minute = parseInt(timeTokens[1]);

    // Don't convert 12 noon to 2400
    if (timePortions[1] == 'PM' && hour != 12) hour += 12;

    let timeValue = new Date(1970, 0, 1, hour, minute, 0);

    return this.datepipe.transform(datePart, 'yyyy-MM-ddT') +
      this.datepipe.transform(timeValue, 'HH:mm:00');
  }

  combineDate(datePart: Date, timePart: string): Date {
    if (datePart == null || timePart == null) return null;

    let timePortions = timePart.split(' ');
    let timeTokens = timePortions[0].split(':');
    let hour = parseInt(timeTokens[0]);
    let minute = parseInt(timeTokens[1]);

    // Don't convert 12 noon to 2400
    if (timePortions[1] == 'PM' && hour != 12) hour += 12;

    let result = new Date(datePart.getFullYear(), datePart.getMonth(), datePart.getDate(), hour, minute, 0);

    return result;
  }

  validateDates(startDate: Date, startTime: string, stopDate: Date, stopTime: string): string {
    startDate = this.combineDate(startDate, startTime);
    stopDate = this.combineDate(stopDate, stopTime);

    if (startDate >= stopDate) {
      return 'Start time must be before stop time';
    } else {
      return null;
    }
  }

  validateTimes(startTime: string, stopTime: string): string {

    // no dates entered just return
    if ((startTime === '-' || startTime === '') && (stopTime === '-' || stopTime === '')) {
      return;
    }
    else if (startTime === '-' || stopTime === '-') {
      return 'both Start time and Stop Time must be entered';
    }

    let startDate = this.getTime(startTime);
    let stopDate = this.getTime(stopTime);

    if (startDate >= stopDate) {
      return 'Start time must be before stop time';
    }
    else {
      return null;
    }
  }

  getTime(timePart: string): number {
    if (timePart == null) return null;

    let timePortions = timePart.split(' ');
    let timeTokens = timePortions[0].split(':');
    let hour = parseInt(timeTokens[0]);
    let minute: string = timeTokens[1];

    // Don't convert 12 noon to 2400
    if (timePortions[1] == 'PM' && hour != 12) hour += 12;

    let result = parseInt(hour.toString().concat(minute));

    return result;
  }

  getTimeHours(timePart: string): number {
    if (timePart == null) return null;

    let timePortions = timePart.split(' ');
    let timeTokens = timePortions[0].split(':');
    let hour = parseInt(timeTokens[0]);

    // Don't convert 12 noon to 2400    
    if (timePortions[1] == 'PM' && hour != 12) hour += 12;

    return hour;
  }

  getTimeMinutes(timePart: string): number {
    if (timePart == null) return null;

    let timePortions = timePart.split(' ');
    let timeTokens = timePortions[0].split(':');
    let hour = parseInt(timeTokens[0]);
    let minutes = parseInt(timeTokens[1]);

    return minutes;
  }

}
